module.exports = __webpack_public_path__ + "static/img/qq2.347c636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qq2.png
// module id = pDhR
// module chunks = 1